import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {ITokensData} from "@containers/auth/types/auth";
import {
	IAdminAccountDetails,
	IAdminAccountRow,
	IBodyCreateAdminAccount,
	IBodyUpdateAdminAccount,
	ISwitchableAccounts,
	ISwitchableUser
} from "@containers/adminAccounts/types";

const BASE_URL = `${BASE_TRACK_API_URL}/v1/admin/accounts`
const JSON_HEADERS = {'Content-Type': 'application/json'}

export const getAdminAccountsApi = async (): Promise<IAdminAccountRow[]> => {
	return await apiRequestWithAuth<IAdminAccountRow[]>({
		url: BASE_URL,
		options: {
			method: 'GET',
		},
	});
};

export const getAdminAccountApi = async (id: number): Promise<IAdminAccountDetails> => {
	return await apiRequestWithAuth<IAdminAccountDetails>({
		url: `${BASE_URL}/${id}`,
		options: {
			method: 'GET',
		},
	});
};

export const createAdminAccountApi = async (body: IBodyCreateAdminAccount): Promise<IAdminAccountDetails> => {
	return await apiRequestWithAuth<IAdminAccountDetails>({
		url: BASE_URL,
		options: {
			method: 'POST',
			body: JSON.stringify(body),
			headers: JSON_HEADERS,
		},
	});
};

export const updateAdminAccountApi = async ({id, ...body}: IBodyUpdateAdminAccount): Promise<IAdminAccountDetails> => {
	return await apiRequestWithAuth<IAdminAccountDetails>({
		url: `${BASE_URL}/${id}`,
		options: {
			method: 'PUT',
			body: JSON.stringify(body),
			headers: JSON_HEADERS,
		},
	});
};

// As the account administrator, the way the legacy accounts page connects, or as one of its users
// the way the legacy users page does.
export const connectToAccountApi = async ({accountCode, login}: { accountCode: string, login?: string | null }): Promise<ITokensData> => {
	return await apiRequestWithAuth<ITokensData>({
		url: `${BASE_TRACK_API_URL}/v1/authenticate/impersonate`,
		options: {
			method: 'POST',
			body: JSON.stringify({accountCode, login: login || 'admin'}),
			headers: JSON_HEADERS,
		},
	});
};

export const getSwitchableAccountsApi = async (): Promise<ISwitchableAccounts> => {
	return await apiRequestWithAuth<ISwitchableAccounts>({
		url: `${BASE_TRACK_API_URL}/v1/authenticate/switchable-accounts`,
		options: {
			method: 'GET',
		},
	});
};

export const getSwitchableUsersApi = async (accountId: number): Promise<ISwitchableUser[]> => {
	return await apiRequestWithAuth<ISwitchableUser[]>({
		url: `${BASE_TRACK_API_URL}/v1/authenticate/switchable-accounts/${accountId}/users`,
		options: {
			method: 'GET',
		},
	});
};

export const setFavoriteAccountApi = async ({id, favorite}: { id: number, favorite: boolean }): Promise<number[]> => {
	return await apiRequestWithAuth<number[]>({
		url: `${BASE_TRACK_API_URL}/v1/authenticate/switchable-accounts/${id}/favorite`,
		options: {
			method: 'PUT',
			body: JSON.stringify({favorite}),
			headers: JSON_HEADERS,
		},
	});
};

export const releaseImpersonationApi = async (): Promise<ITokensData> => {
	return await apiRequestWithAuth<ITokensData>({
		url: `${BASE_TRACK_API_URL}/v1/authenticate/release`,
		options: {
			method: 'POST',
		},
	});
};
